<p-drawer
  [(visible)]="visible"
  (onHide)="fecharDrawer()"
  position="right"
  [modal]="true"
  [closable]="false"
  [dismissible]="true"
  [style]="{ width: 'min(95vw, 850px)' }"
  styleClass="ocorrencia-detail-dialog efetivo-drawer-dark"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="header-title">
        <i class="pi pi-check-circle header-icon"></i>
        <div>
          <h2>Fechar Ocorrência</h2>
          <p class="header-subtitle">
            ID #{{ ocorrencia?.id }} • {{ getTipoLabel(ocorrencia?.tipoOcorrencia) }}
            <span *ngIf="ocorrencia?.dataOcorrencia"> • Registada {{ ocorrencia?.dataOcorrencia | date: 'dd/MM/yyyy HH:mm' }}</span>
          </p>
        </div>
      </div>
      <div class="header-actions">
        <p-tag
          *ngIf="ocorrencia?.criticidade"
          [value]="getCriticidadeLabel(ocorrencia?.criticidade)"
          [severity]="getCriticidadeSeverity(ocorrencia?.criticidade)"
          [rounded]="true"
          class="header-tag"
        ></p-tag>
        <p-tag
          *ngIf="ocorrencia?.estadoEnum || ocorrencia?.estado"
          [value]="getEstadoLabel(ocorrencia?.estado)"
          [severity]="getEstadoSeverity(ocorrencia?.estado)"
          [rounded]="true"
          class="header-tag"
        ></p-tag>
        <button type="button" class="close-btn" (click)="fecharDrawer()" aria-label="Fechar">
          <i class="ri-close-line"></i>
        </button>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">
    <form [formGroup]="form" class="dialog-form">
      <div class="form-group">
        <label class="field-label">DESFECHO <span class="req">*</span></label>
        <p-select
          formControlName="desfecho"
          [options]="opcoesDesfecho"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o desfecho"
          appendTo="body"
        ></p-select>
        <small class="field-error" *ngIf="temErro('desfecho')">O desfecho é obrigatório.</small>
      </div>

      <div class="form-group">
        <label class="field-label">ACÇÕES TOMADAS <span class="req">*</span></label>
        <textarea
          pInputTextarea
          formControlName="acoesTomadas"
          rows="4"
          placeholder="Descreva as acções tomadas para resolver a ocorrência"
        ></textarea>
        <small class="field-error" *ngIf="temErro('acoesTomadas')">As acções tomadas são obrigatórias.</small>
      </div>

      <div class="form-grid-2">
        <div class="form-group">
          <label class="field-label">DATA E HORA <span class="req">*</span></label>
          <p-datepicker
            formControlName="dataResolucao"
            [showTime]="true"
            [showIcon]="true"
            [minDate]="minDateResolucao"
            appendTo="body"
            dateFormat="dd/mm/yy"
          ></p-datepicker>
          <small class="field-error" *ngIf="temErro('dataResolucao')">A data e hora da resolução são obrigatórias.</small>
        </div>
        <div class="form-group">
          <label class="field-label">RESOLVIDO POR</label>
          <input pInputText [value]="resolvidoPor" [disabled]="true" />
        </div>
      </div>

      <div class="form-group">
        <label class="field-label">ENTIDADES ACCIONADAS <span class="opt">- opcional</span></label>
        <div class="chips-group">
          <button
            type="button"
            class="chip-btn"
            *ngFor="let ent of entidadesOpcoes"
            [class.active]="isEntidadeSeleccionada(ent)"
            (click)="toggleEntidade(ent)"
          >
            {{ ent }}
          </button>
        </div>
        <div class="outra-entidade" *ngIf="temOutraEntidade">
          <input
            pInputText
            [(ngModel)]="outraEntidade"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onOutraEntidadeChange()"
            placeholder="Especifique a entidade"
          />
        </div>
        <input type="hidden" formControlName="entidadesAccionadas" />
      </div>

      <div class="form-group">
        <div class="toggle-row">
          <label class="field-label">Houve danos ou perdas?</label>
          <div class="toggle-group">
            <button type="button" class="toggle-btn" [class.active]="!temDanosPerdas" (click)="toggleDanosPerdas(false)">Não</button>
            <button type="button" class="toggle-btn" [class.active]="temDanosPerdas" (click)="toggleDanosPerdas(true)">Sim</button>
          </div>
        </div>
        <div class="form-grid-2 danos-grid" *ngIf="temDanosPerdas">
          <div class="form-group">
            <label class="field-label">VALOR (Kz)</label>
            <input type="number" pInputText formControlName="valorDanosPerdas" placeholder="0.00" min="0" />
            <small class="field-error" *ngIf="temErro('valorDanosPerdas')">O valor não pode ser negativo.</small>
          </div>
          <div class="form-group">
            <label class="field-label">DESCRIÇÃO</label>
            <input pInputText formControlName="descricaoDanosPerdas" placeholder="Descreva os danos/perdas" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="field-label">ANEXOS DA RESOLUÇÃO <span class="opt">- opcional</span></label>
        <label class="upload-zone">
          <input type="file" multiple accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" (change)="onFileSelect($event)" />
          <div class="upload-zone-content">
            <div class="upload-icon">
              <i class="pi pi-cloud-upload"></i>
            </div>
            <div class="upload-text">
              <div class="upload-title">Clique para anexar fotos ou documentos</div>
              <div class="upload-subtitle">Imagem, PDF ou Word</div>
            </div>
          </div>
        </label>
        <div class="anexos-preview" *ngIf="anexos.length">
          <div class="anexo-item" *ngFor="let anexo of anexos; let i = index">
            <img *ngIf="anexo.preview.startsWith('data:image')" [src]="anexo.preview" alt="Anexo" />
            <div class="anexo-icon" *ngIf="!anexo.preview.startsWith('data:image')">
              <i class="pi pi-file"></i>
            </div>
            <button type="button" class="anexo-remove" (click)="removerAnexo(i)">
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button type="button" class="btn-web-secondary" (click)="fecharDrawer()" [disabled]="isSaving">Cancelar</button>
      <button type="button" class="btn-web-primary" (click)="guardar()" [disabled]="isSaving">
        <i class="pi pi-check" *ngIf="!isSaving"></i>
        <span>{{ isSaving ? 'A fechar...' : 'Fechar ocorrência' }}</span>
      </button>
    </div>
  </ng-template>
</p-drawer>
